import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterModule } from '@commons/footer/footer.module';
import { HtmlParseService } from '@commons/html-parser/html-parse.service';
import { LogoModule } from '@commons/logo/logo.module';
import { SharePopupModule } from '@commons/share-popup/share-popup.module';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { TrackerModule } from '@commons/tracker/tracker.module';
import { FormSuccessModule } from '@domains/applications/form-success/form-success.module';
import { FormModule } from '@domains/applications/form/form.module';
import { I18nContractDurationModule } from '@domains/jobs/i18n-contract-duration/i18n-contract-duration.module';
import { I18nContractModule } from '@domains/jobs/i18n-contract/i18n-contract.module';
import { I18nDomainModule } from '@domains/jobs/i18n-domain/i18n-domain.module';
import { I18nExperienceModule } from '@domains/jobs/i18n-experience/i18n-experience.module';
import { I18nStudyLevelModule } from '@domains/jobs/i18n-study-level/i18n-study-level.module';
import { ListSkeletonModule } from '@domains/jobs/list-skeleton/list-skeleton.module';
import { ApplyComponent } from '@features/job/apply/apply.component';
import { JobRoutingModule } from '@features/job/job-routing.module';
import { DescriptionComponent } from '@features/job/job/description/description.component';
import { JobComponent } from '@features/job/job/job.component';
import { LocationComponent } from '@features/job/job/location/location.component';
import { ProfilComponent } from '@features/job/job/profil/profil.component';
import { SalaryComponent } from '@features/job/job/salary/salary.component';
import { NgxsModule } from '@ngxs/store';
import { ApplicationsState } from '@store/applications/applications.state';
import { JobsState } from '@store/jobs/jobs.state';
import { MemoizePipeModule } from '@wizbii/angular-utils';
import { ScrollToModule } from '@wizbii/nicky-lenaers_ngx-scroll-to';
import { HeadDescriptionModule, HeadTitleModule } from '@wizbii/seo-lib';

@NgModule({
  declarations: [
    JobComponent,
    ApplyComponent,
    DescriptionComponent,
    LocationComponent,
    ProfilComponent,
    SalaryComponent,
  ],
  providers: [HtmlParseService],
  imports: [
    CommonModule,
    NgxsModule.forFeature([JobsState, ApplicationsState]),
    LogoModule,
    SvgIconModule,
    ScrollToModule,
    JobRoutingModule,
    ListSkeletonModule,
    I18nContractModule,
    I18nExperienceModule,
    I18nContractDurationModule,
    I18nStudyLevelModule,
    I18nDomainModule,
    SharePopupModule,
    HeadTitleModule,
    HeadDescriptionModule,
    FormModule,
    FormSuccessModule,
    MemoizePipeModule,
    FooterModule,
    TrackerModule,
  ],
})
export class JobModule {}
